// known request-id header formats
const X_MACYS_REQUEST_ID = 'x-macys-request-id';
const X_REQUEST_ID = 'x-request-id';
const X_MACYS_REQUESTID = 'x-macys-requestid';

const getRequestId = (headers) => {
  if (headers[X_MACYS_REQUEST_ID]) { return headers[X_MACYS_REQUEST_ID]; }
  if (headers[X_MACYS_REQUESTID]) { return headers[X_MACYS_REQUESTID]; }
  if (headers[X_REQUEST_ID]) { return headers[X_REQUEST_ID]; }
  return 'NO_REQUEST_ID';
};

module.exports = (info) => {
  const cookies = info.cookies || null;
  const macysOnlineGuid = cookies ? cookies.macys_online_guid || 'GUEST' : 'GUEST';
  const macysOnlineUid = cookies ? cookies.macys_online_uid || 'GUEST' : 'GUEST';
  const TLTSID = cookies ? cookies.TLTSID || 'Unknown' : 'Unknown';
  const macysBagGuid = cookies ? cookies.macys_bagguid || 'Unknown' : 'Unknown';

  const version = info.version ? `@${info.version}` : null;
  let name = info.name || null;
  if (name) {
    name = version ? `${name}${version}` : name;
  } else {
    name = 'NO_NAME';
  }
  const file = info.file ? info.file : 'NO_FILENAME';
  const requestId = info.headers ? getRequestId(info.headers) : 'NO_REQUEST_ID';
  // Handle preformatted messages
  info.message = info.preformatted || `TR=${info.timestamp || 'NO_TIMESTAMP'}|LL=${info.level || 'debug'}|RID=${requestId}|CID=${name}|CN=${file}|UID=${macysOnlineUid}|GUID=${macysOnlineGuid}|TLTSID=${TLTSID}|BAGGUID=${macysBagGuid}|MSG=${info.message || 'NO_MESSAGE'}|EXP=${info.exception || 'NO_EXCEPTION'}`;
  return info;
};



// WEBPACK FOOTER //
// ../util/server-logger/formatter.js